import { grey } from '../../../../utils/brandColors';

export default () => ({
  paperRoot: {
    overflow: 'auto',
    marginTop: '1rem',
  },
  row: {
    cursor: 'pointer',
    '&:hover': { background: grey[50] },
  },
  rowInactive: {
    background: grey[300],
    cursor: 'pointer',
    '&:hover': { background: grey[100] },
  },
});
